import * as React from "react";
import {Fragment} from "react";
import JobCreatedFromQuoteNotification from "../../../model/notification/job/JobCreatedFromQuoteNotification";

interface ComponentProps {
	/**
	 * Notification to display in toaster.
	 */
	notification: JobCreatedFromQuoteNotification;
}

/**
 * Job created from quote notification toast body.
 */
const NotificationJobCreatedFromQuoteBody: React.SFC<ComponentProps> = (props) => {
	return (
		<Fragment>
			<div className={"toast-header"}>Job {props.notification.data.referenceNumber}</div>
			<div className={"toast-body"}>
				Job {props.notification.data.referenceNumber} has been created from quote
			</div>
		</Fragment>
	);
};

export default NotificationJobCreatedFromQuoteBody;
